<app-quota-summary-bar></app-quota-summary-bar>
<div class="register-container">
  <div class="register-header">
    <h1>{{ 'quotasAdmin.title' | translate }}</h1>
    @if (!isManager()) {
      <div class="add-btn-wrapper">
        <button mat-raised-button class="add-btn"
                (click)="addQuotaLimits()"
                [disabled]="currentYearQuotasExist()">
          <mat-icon>add</mat-icon>
          {{ 'quotasAdmin.addLimits' | translate }}
        </button>
        @if (currentYearQuotasExist()) {
          <span class="limit-warning">{{ 'quotasAdmin.limitWarning' | translate }}</span>
        }
      </div>
    }
  </div>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ 'quotasAdmin.loading' | translate }}</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error() }}</p>
      <button mat-raised-button color="primary" (click)="loadQuotas()">
        {{ 'quotasAdmin.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="table-container">
      <table mat-table [dataSource]="quotas()" class="quotas-table">
        <!-- № -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="text-right">№</th>
          <td mat-cell *matCellDef="let quota; let i = index" class="text-right">
            {{ pagination.currentPage() * pagination.pageSize() + i + 1 }}
          </td>
        </ng-container>

        <!-- Год -->
        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'quotasAdmin.year' | translate }}</th>
          <td mat-cell *matCellDef="let quota" class="text-center">{{ quota.year }}</td>
        </ng-container>

        <!-- Статус квоты -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'quotasAdmin.quotaStatus' | translate }}</th>
          <td mat-cell *matCellDef="let quota">
            <span class="status-chip" [ngClass]="getStatusClass(quota.status)">
              {{ quota.status | quotaStatus }}
            </span>
          </td>
        </ng-container>

        <!-- Вид мяса -->
        <ng-container matColumnDef="meatType">
          <th mat-header-cell *matHeaderCellDef>{{ 'quotasAdmin.meatType' | translate }}</th>
          <td mat-cell *matCellDef="let quota">{{ getMeatTypeName(quota.meatType) }}</td>
        </ng-container>

        <!-- Общий лимит -->
        <ng-container matColumnDef="totalLimitVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'quotasAdmin.totalLimit' | translate }}</th>
          <td mat-cell *matCellDef="let quota" class="text-right">{{ quota.totalLimitVolume | kgToTons }}</td>
        </ng-container>

        <!-- Распределено -->
        <ng-container matColumnDef="allocatedVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'quotasAdmin.allocated' | translate }}</th>
          <td mat-cell *matCellDef="let quota" class="text-right">{{ quota.allocatedVolume | kgToTons }}</td>
        </ng-container>

        <!-- Остаток -->
        <ng-container matColumnDef="remainderVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'quotasAdmin.remainder' | translate }}</th>
          <td mat-cell *matCellDef="let quota" class="text-right">{{ quota.remainderVolume | kgToTons }}</td>
        </ng-container>

        <!-- Действия -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'quotasAdmin.action' | translate }}</th>
          <td mat-cell *matCellDef="let quota" class="text-center">
            <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{quota: quota}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <mat-menu #actionsMenu="matMenu">
          <ng-template matMenuContent let-quota="quota">
            <button mat-menu-item (click)="editQuota(quota)">
              <!-- <mat-icon>edit</mat-icon> -->
              <span>{{ 'quotasAdmin.edit' | translate }}</span>
            </button>
          </ng-template>
        </mat-menu>

        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>

        <!-- Пустое состояние -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns().length">
            {{ 'quotasAdmin.noQuotas' | translate }}
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="pagination.totalElements()"
      [pageSize]="pagination.pageSize()"
      [pageIndex]="pagination.currentPage()"
      [pageSizeOptions]="[10, 15, 25, 50]"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  }
</div>
